// NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
let RivalIQ;
if (typeof window === 'undefined') {

    RivalIQ = {
        utils: {}
    };

} else {
    RivalIQ = window.RivalIQ;
    RivalIQ.module('utils', function () {});
}

(function () {

    'use strict';


    const typeaheadPreclean = {};

    typeaheadPreclean.cleanSearch = function (query) {

        const MIN_LENGTH = 3;
        let hostQuery = '';
        let pathQuery = '';
        let protocol = null;

        // short circuit the checking if the passed in string is too short
        if (query && query.length >= MIN_LENGTH) {

            // rip off the protocol, but save it away to help the typeahead matcher later
            const protocolMatch = query.match(/^https?:\/\//i, '');
            protocol = (protocolMatch ? protocolMatch[0].toLowerCase() : '');

            if (query.match(/^https?:\/\//i)) {
                query = query.replace(/^https?:\/\//i, '');
            } else if (query.match(/^https?:\//i)) {
                query = query.replace(/^https?:\//i, '');
            } else if (query.match(/^https?:/i)) {
                query = query.replace(/^https?:/i, '');
            } else if (query.match(/^https?/i)) {
                query = query.replace(/^https?/i, '');
            } else if (query.match(/^htt/i)) {
                query = query.replace(/^htt/i, '');
            }

            // rip off the leading www. so that we don't try to match on it
            query = query.replace(/^www\.?/i, '');

            // split host from path
            hostQuery = query.replace(/^([^/]+)\/.*$/, '$1');
            const pathQueryMatch = query.match(/^[^/]+\/([^?]*).*$/);
            if (pathQueryMatch && pathQueryMatch[1]) {
                pathQuery = pathQueryMatch[1];
            }

            // check that what we're querying for is long enough
            if (hostQuery.length < MIN_LENGTH) {
                hostQuery = '';
            }
        }

        return {
            hostQuery: hostQuery,
            pathQuery: pathQuery,
            protocol: protocol
        };
    };

    // NOTE export the results, for both server and client
    if (typeof window === 'undefined') {
        module.exports = typeaheadPreclean;
    } else {
        RivalIQ.utils.typeaheadPreclean = typeaheadPreclean;
    }

})();
